// Maps the runtime hostname to one of the favicon folders shipped in `public/favicons/`.
//
// We resolve this from `window.location.hostname` rather than calling a backend endpoint
// because:
//   - Acorn is a static site whose only backend is the cloud function (cloud-func.*),
//     which does not proxy `/timber/...` (the host of the SPA config endpoint).
//   - The favicon folder is purely an environment marker; the hostname already encodes it
//     and is stable across infra changes.
//
// Available folders are kept in sync with `public/favicons/<folder>/favicon.ico`.

export type EnvImagesFolder = 'preview' | 'preprod' | 'prod';

export const getImagesFolder = (hostname: string = window.location.hostname): EnvImagesFolder => {
  // Order matters: check the most specific markers first.
  if (hostname.includes('preprod')) {
    return 'preprod';
  }
  if (
    hostname.includes('.review.') ||
    hostname.includes('localhost') ||
    hostname.includes('127.0.0.1')
  ) {
    return 'preview';
  }
  return 'prod';
};
